function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M5.332 1.6A3.74 3.74 0 0 0 1.6 5.334v5.334A3.74 3.74 0 0 0 5.334 14.4h5.334a3.74 3.74 0 0 0 3.732-3.734V5.332A3.74 3.74 0 0 0 10.666 1.6zm6.401 2.133a.534.534 0 1 1 0 1.068.534.534 0 0 1 0-1.068M8 4.8c1.765 0 3.2 1.435 3.2 3.2S9.765 11.2 8 11.2A3.203 3.203 0 0 1 4.8 8c0-1.765 1.435-3.2 3.2-3.2m0 1.067a2.133 2.133 0 1 0 0 4.267 2.133 2.133 0 0 0 0-4.267"
});

var SvgInstagram = function SvgInstagram(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    fill: "none",
    className: "mx-1 c-neutral-200",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInstagram, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/instagram.6255a27d.svg";
export { ForwardRef as ReactComponent };